import { Fade } from "react-awesome-reveal";
import Faq from "react-faq-component";
import FAQData from "../Constant/FAQData";

const styles = {
	bgColor: "rgb(235, 231, 224)",
	titleTextColor: "#ff8059",
	titleTextSize: '1.8em',
	rowTitleColor: "black",
	rowTitleTextSize: '1.2em',
	// rowContentColor: 'grey',
	rowContentTextSize: "1em",
	// rowContentPaddingTop: '10px',
	rowContentPaddingBottom: "10px",
	rowContentPaddingLeft: "50px",
	// rowContentPaddingRight: '150px',
	// arrowColor: "red",
	transitionDuration: ".7s",
	timingFunc: "ease"
};

const config = {
	animate: true,
	arrowIcon: "V",
	openOnload: 0,
	expandIcon: "+",
	collapseIcon: "-",
};

const FAQSection = ({slug, sectionBg = false }) => {
  const data = FAQData[slug];
  if (!data) return null;
	return (
		<section
			className={`section-parallax-3 call-to-action-section section ${
				sectionBg ? "section-bg" : ""
			}`}
			id="call-to-action-section"
		>
			<Fade direction="up" cascade={true} damping={0.5} delay={400} triggerOnce>
				<div className="container">
					<Faq data={data} styles={styles} config={config} />
				</div>
			</Fade>
		</section>
	);
};
export default FAQSection;
